import { targetingTypes } from '../../../LineItemDv360Create/fields'
import { CUSTOM_AGE_RANGES } from '../../../../../ReusableFormFields/AgeRangesFields/fields'
import { AGE_RANGE_65_PLUS } from '../../../../../../constants/ageRanges'

export const getAgeRangePreview = targeting => {
  const ageRanges = targeting.filter(item => item.type === targetingTypes.TARGETING_TYPE_AGE_RANGE)

  if (!ageRanges.length) {
    return 'All ages'
  }

  const sortedAgeRanges = ageRanges.sort((a, b) => a.targeting_option_id - b.targeting_option_id)

  const minAgeRange = sortedAgeRanges[0]
  const maxAgeRange = sortedAgeRanges[sortedAgeRanges.length - 1]

  const minAgePreview = minAgeRange?.age_range.split('_')[2]
  const maxAgePreview = maxAgeRange.age_range === AGE_RANGE_65_PLUS ? '65 +' : maxAgeRange.age_range.split('_')[3]

  if (minAgeRange.age_range === maxAgeRange.age_range && minAgeRange.age_range === AGE_RANGE_65_PLUS) {
    return `65 + years old`
  }

  return `${minAgePreview} - ${maxAgePreview} years old`
}

export const getAgeRangesIds = values => {
  const ageRangesIds = Object.keys(values[CUSTOM_AGE_RANGES]).filter(ageRange => values[CUSTOM_AGE_RANGES][ageRange])

  return ageRangesIds
}
